const vendors = ['ms', 'moz', 'webkit', 'o'];

type RequestProperty =
  'msRequestAnimationFrame'
  | 'mozRequestAnimationFrame'
  | 'webkitRequestAnimationFrame'
  | 'oRequestAnimationFrame';

type RequestAnimationFrameCallback = (time: number) => void;

function getRequestAnimationFrame() {
  let func;

  if (window.requestAnimationFrame) func = window.requestAnimationFrame;

  for (let x = 0; x < vendors.length && !func; ++x) {
    const property: RequestProperty = `${vendors[x]}RequestAnimationFrame` as RequestProperty;
    //@ts-ignore
    func = window[property] as ((cb: RequestAnimationFrameCallback) => number) | null;
    if (func) break;
  }

  if (!func) {
    let lastTime = 0;
    func = (cb: RequestAnimationFrameCallback) => {
      const currTime = new Date().getTime();
      const timeToCall = Math.max(0, 16 - (currTime - lastTime));
      const id = window.setTimeout(() => {
        cb(currTime + timeToCall);
      }, timeToCall);
      lastTime = currTime + timeToCall;
      return id;
    };
  }

  return func.bind(window);
}

function getCancelAnimationFrame() {
  let func;

  if (window.cancelAnimationFrame) func = window.cancelAnimationFrame;

  for (let x = 0; x < vendors.length && !func; ++x) {
    const property = `${vendors[x]}CancelAnimationFrame`;
    const propertyAlt = `${vendors[x]}CancelRequestAnimationFrame`;
    //@ts-ignore
    func = window[property] || window[propertyAlt];
    if (func) break;
  }

  if (!func) {
    func = (id: number) => {
      clearTimeout(id);
    };
  }

  return func.bind(window);
}

export const requestAnimationFrame = getRequestAnimationFrame();
export const cancelAnimationFrame = getCancelAnimationFrame();
